module.exports = __webpack_public_path__ + "img/bring-front.52490594.svg";